<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <a-form-model layout="inline" :model="searchForm.data">
          <a-form-model-item
            label="日志时间">
            <a-date-picker
              v-model="searchForm.data.timeScope"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item label="事件">
            <a-input v-model="searchForm.data.event" allowClear/>
          </a-form-model-item>
          <a-form-model-item>
            <a-button
              type="primary"
              plain
              icon="el-icon-search"
              @click="getLogList">{{ $t('SEARCH') || '查询' }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-table
        :data-source="table.data"
        :default-sort="table.sort"
        height="500"
        style="width: 100%">
        <a-table-column
          data-index="createUser.userName"
          title="人员"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="event"
          title="事件">
        </a-table-column>
        <a-table-column
          data-index="url"
          :sorter="true"
          title="请求地址">
        </a-table-column>
        <a-table-column
          data-index="description"
          title="数据">
          <template slot-scope="text,record">
            <span
              class="diff_object"
              :key="record.id+node"
              v-for="(val,node) in record.description">
              {{ node }}:{{ val.oldValue ? `${val.oldValue} -> ` : '' }}{{ val.currentValue }}
            </span>
          </template>
        </a-table-column>
        <a-table-column
          data-index="createAt"
          :sorter="true"
          title="时间">
        </a-table-column>
      </a-table>
      <a-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="this.table.query.page"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="this.table.query.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.table.query.total">
      </a-pagination>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment';
import {
  _queryLogs,
  _deleteLog,
} from '@/api/sysLogApi';

async function getLogList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2
    ? this.searchForm.data.timeScope : [null, null];
  const { content, totalElements } = await _queryLogs({
    page: this.table.query.page,
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    event: this.searchForm.data.event,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = content.map(x => ({
    id: x.id,
    createUser: x.createUser,
    event: x.event,
    url: x.url,
    description: JSON.parse(x.description),
    createAt: x.createAt,
  }));
  this.table.query.total = totalElements;
}

function addLog() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editLog(logId) {
  this.form.data.id = logId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getLogList();
}

async function deleteLog(logId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteLog(logId);
      if (result) {
        this.$message.success('删除成功');
        this.getLogList();
      }
    },
  });
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getLogList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getLogList();
}

export default {
  name: 'LogList',
  components: {},
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      searchForm: {
        data: {
          timeScope: [],
          event: '',
        },
      },
      table: {
        start: '',
        end: '',
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getLogList,
    deleteLog,
    editLog,
    addLog,
    closeForm,
    handlePageChange,
    handleSizeChange,
  },
  created() {
    this.getLogList();
  },
};
</script>

<style scoped>
.diff_object {
  margin: 0 3px;
  padding: 0 3px;
  color: #171616;
  border-right: 1px solid #c5c5c5;
}

.diff_object:last-child {
  border-right: unset;
}
</style>
